<template>
  <v-app class="bg-lightBlue">
    <v-container>
      <v-row class="justify-start">
        <v-col class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="d-inline-flex primary--text">
            <h2 class="text-md-left primary--text">Edição de Conta Digital</h2>
          </div>
        </v-col>
      </v-row>
      <v-form v-model="isFormValid">
        <v-row class="justify-center">
          <v-col class="col-12 col-md-9 col-lg-6 col-xl-5">
            <v-row class="justify-center">
              <v-col class="col-12 col-md-9 pt-0 mt-5">
                <v-text-field
                  filled
                  label="Digite o nome da empresa"
                  required
                  hide-details="auto"
                  :rules="rules"
                  v-model="nome"
                  v-if="lang === 'pt'"
                ></v-text-field>

                <template v-if="lang === 'pt-BR'">
                  <v-select
                    :items="banks"
                    label="Banco"
                    v-model="bankNumber"
                    item-value="value"
                    class="mt-5"
                    :rules="rules"
                    required
                    flat
                    filled
                    hide-details="auto"
                  ></v-select>

                  <v-text-field
                    filled
                    :label="$t('dateBank.identifyNumber')"
                    required
                    class="input-banco mt-5"
                    hide-details="auto"
                    :rules="rules"
                    v-model="cpf"
                  ></v-text-field>

                  <v-text-field
                    filled
                    label="Número da agência"
                    required
                    class="mt-5"
                    hide-details="auto"
                    :rules="rules"
                    v-model="agencyNumber"
                  ></v-text-field>
                </template>

                <v-text-field
                  filled
                  label="Número da conta"
                  required
                  class="mt-5"
                  hide-details="auto"
                  :rules="rules"
                  v-model="codigoIban"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      <div class="d-flex flex-column align-center justify-center mt-5">
        <v-btn
          large
          color="secondary"
          :disabled="!isFormValid || isLoading"
          :loading="isLoading"
          @click="confirmChanges"
          style="align-self: center"
        >
          Confirmar
        </v-btn>
        <v-btn class="mt-3" text style="align-self: center" @click="$router.go(-1)">
          Cancelar
        </v-btn>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { editBankAccount, getProfile } from '../../services/psychologists';
import getLanguage from '../../utils/getLanguage';
import axios from 'axios'

export default {
  name: 'EdicaoBancario',
  data() {
    return {
      banks: [],
      isFormValid: false,
      isLoading: false,
      nome: '',
      codigoIban: '',
      bankNumber: '',
      agencyNumber: '',
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      lang: '',
      cpf: ''
    };
  },
  async created() {
    const localUser = JSON.parse(localStorage.getItem('user-data'));
    const res = await getProfile(localUser.id);
    this.nome = res.digital_account.name;
    this.codigoIban = res.digital_account.iban_code;
    if (res.digital_account.routing_number) {
      this.bankNumber = res.digital_account.routing_number.split('-')[0]
      this.agencyNumber = res.digital_account.routing_number.split('-')[1]
    }
    this.cpf = res.digital_account.vat_number;
    this.lang = getLanguage(window.location.href);
    this.getBankArray();
  },
  methods: {
    async confirmChanges() {
      this.isLoading = true;
      const dataForm = {
        name: this.nome,
        iban_code: this.codigoIban,
        routing_number: this.bankNumber ? `${this.bankNumber}-${this.agencyNumber}`: null,
        tax_document: this.cpf
      };

      try {
        await editBankAccount(dataForm);
        this.$showSnackbar('Cadastro bancário realizado com sucesso.');
        this.$router.go(-1);
      } catch (error) {
        this.$showSnackbar(error[0]);
      } finally {
        this.isLoading = false;
      }
    },
    async getBankArray() {
      const { data } = await axios.get('https://brasilapi.com.br/api/banks/v1');
      this.bankNumber = parseInt(this.bankNumber)
      this.banks = data
        .filter((bank) => bank.code)
        .sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        })
        .map((bank) => ( {
          text: bank.name,
          value: bank.code,
          select: bank.code === this.bankNumber ? true : false
        }));
    },
  },
};
</script>
